// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var MarginRequestMode;
(function (MarginRequestMode) {
    MarginRequestMode[MarginRequestMode["InitMargin"] = 1] = "InitMargin";
    MarginRequestMode[MarginRequestMode["SuppMargin"] = 2] = "SuppMargin";
    MarginRequestMode[MarginRequestMode["WarnMargin"] = 4] = "WarnMargin";
    MarginRequestMode[MarginRequestMode["All"] = 7] = "All"; //InitMargin & SuppMargin & WarnMargin
})(MarginRequestMode || (MarginRequestMode = {}));
